//export const API_BASE_URL = 'http://localhost:8110/api';

export const API_BASE_URL = 'https://api.tryonhaulcentral.com/api';
export const CDN_BASE_URL = 'https://cdn.tryonhaulcentral.com';
export const THUMBNAIL_CDN_BASE_URL = 'https://thumbnails.tryonhaulcentral.com';
export const AVATAR_CDN_BASE_URL = 'https://cg-avatar.tryonhaulcentral.com';

